module.exports = __webpack_public_path__ + "static/img/reporticon6.9fd61bbe.png";